import React, {Component}  from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import App from './App';
import NoMatch from './pages/NoMatch';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Offers from './pages/Offers';
import FAQ from './pages/FAQ';
import ShippingHandling from './pages/ShippingHandling';
import Contact from './pages/Contact';
import Locator from './pages/Locator';

import axios from 'axios';
import scrollToElement from 'scroll-to-element';
const loadScript = require('simple-load-script');

export default class Routes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      windowWidth: 0,
      products: [],
      googleMapsLoaded: false,
      googleMapsObject: null,
      cartItemCount: 0,
      cartPriceTotal: 0,
      user: null,
      userLoggedIn: false,
      previousRoute: {},
      currentRoute: {},
      homeIsMounted: false,
      shopIsMounted: false,
      itemAddedPopupOpen: false,
      itemAddedPopupName: "",
      itemAddedPopupQuantity: 0,
      itemAddedPopupImage: ""

    };
  }

  setHomeIsMounted = () => { this.setState({ homeIsMounted: !this.state.homeIsMounted }) }
  setShopIsMounted = () => { this.setState({ shopIsMounted: !this.state.shopIsMounted }) }
  setPreviousRoute = (previousRoute) => { this.setState({ previousRoute }) }
  setCurrentRoute = (currentRoute) => { this.setState({ currentRoute }) }

  componentDidMount() {
    this.loadSnipcartJQuery();
    this.loadGoogleMaps();
    this.setProductsState();
    window.onresize = () => this.setWindowWidth();
    this.setWindowWidth();
  }
  componentWillUnmount() {
    window.onresize = null;
  }

  setDefaultCartStateValues = () => {
    let cartItemCount = 0;
    let cartPriceTotal = 0;
    let user = null;
    let userLoggedIn = false;

    try {
      window.Snipcart.api.items.all().map((item, index) => {
        cartPriceTotal += (item.price * item.quantity);
        cartItemCount += item.quantity;
      });

      user = window.Snipcart.api.user.current();
      if(typeof(user) !== "undefined" && user !== null) { userLoggedIn = true; }
        else { userLoggedIn = false;}

      this.setCartItemCount(cartItemCount);
      this.setCartPriceTotal(cartPriceTotal);
      this.setUser(user);
      this.setUserLoggedIn(userLoggedIn);
    }
    catch(err) {
      console.log("Error accessing Snipcart API");
    }
  }

  addItemToCart = (id, name, price, url, size, sizeDisplay, image, addOneOnly) => {
    let quantity = 1;
    // Sent as true if an item is added from 'Featured' section on Home.
    if(!addOneOnly) {
      quantity = Number(document.getElementById("quantity" + id).value);
    }
  
    this.addItemToCartState(quantity, price*quantity);

    if(quantity == null || quantity < 1 || quantity == "") {
      quantity = 1;
    }

    if(Number(price) < 1) {
      price = Number(price);
    }

    name = `${name} ${sizeDisplay}`;
    try {
        window.Snipcart.api.items.add({
          "id": id,
          "name": name,
          "price": price,
          "url": url,
          "weight": size,
          "quantity": quantity,
          "image": image
        });

        this.itemAddedPopup(name, quantity, image);
    }
    catch(err) {
      console.log("Snipcart not loaded properly.")
    }


  }

  addItemToCartState = (quantityToAdd, totalToAdd) => {
    this.setState({
      cartItemCount: this.state.cartItemCount + quantityToAdd,
      cartPriceTotal: this.state.cartPriceTotal + totalToAdd
    });
  }

  setCartItemCount = (cartItemCount) => { this.setState({ cartItemCount }); }
  setCartPriceTotal = (cartPriceTotal) => { this.setState({ cartPriceTotal }); }
  setUser = (user) => { this.setState({ user }); }
  setUserLoggedIn = (userLoggedIn) => { this.setState({ userLoggedIn }); }

  logoutClick = () => { this.eventFire(document.getElementById("logoutMock"), 'click'); this.setDefaultCartStateValues(); }
  loginClick = () => { this.eventFire(document.getElementById("loginMock"), 'click'); }
  loggedInEmailClick = () => { this.eventFire(document.getElementById("loginMock"), 'click'); }

  setProductsState = () => {
    axios.get('https://s3.amazonaws.com/primitivescandlesstorage/products/info/Products.json')
      .then(response => {
        this.setState({
          products: response.data
        });
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  validatePhone = (value) => {
    let validated = false;
    if(value.length > 6 && value.length < 20) { return value.match(/\d/g); }
    return validated;
  }

  loadSnipcartJQuery = () => {
    const jquery = "https://ajax.googleapis.com/ajax/libs/jquery/2.2.2/jquery.min.js";
    const snipcart = "https://cdn.snipcart.com/scripts/2.0/snipcart.js";
    let jqueryLoaded = this.isScriptLoaded(jquery);
    let snipcartLoaded = this.isScriptLoaded(snipcart);

    // Load JQuery
    if(!jqueryLoaded) {
      loadScript(jquery)

        // Use JQuery script
        .then( (script) => {

          // Then load Snipcart
          if(!snipcartLoaded) {

            loadScript({
              url: snipcart, 
              attrs: {id: "snipcart", "data-api-key": "MTZlNWY1MjEtYWE5NC00ZjczLWIxMjEtNDBkMDIyM2ZiYjZmNjM2NDQyMDA0ODcwMjM1NDY1", 
                      "data-autopop": false,
                      "show-continue-shopping": true,
                      "data-cart-custom1-name": "Delivery option (shipping will be added) or Pick up in person",
                      "data-cart-custom1-options": "Deliver to me|Pick up in Galeton, PA"} })

            // Use snipcart script
            .then( (script) => {  
              this.snipcartScriptLoaded();
            })
            .catch( (err) => {
              console.log(`Snipcart load error: ${err}`);
              // |Pick up in Galeton, PA" above if we ever need second option back
            })
          }

        })
        .catch( (err) => {
          console.log(`JQuery load error: ${err}`);
        })
    }
  }

  snipcartScriptLoaded = () => {
    window.Snipcart.api
    .configure("show_continue_shopping", true)

    document.addEventListener("snipcart.ready", () => {
      this.setDefaultCartStateValues();
    }, false);
  }

  loadGoogleMaps = () => {
    const googleMaps = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBLfMrXVXEYKIR7nUho9Q6Iq3XuZvNX5K0";
    let googleMapsLoaded = this.isScriptLoaded(googleMaps);

    if(!googleMapsLoaded) {
      loadScript({
        url: googleMaps
      })
      .then( (script) => {
        this.setState({
          googleMapsLoaded: true,
          googleMapsObject: window.google.maps
        });
      })
      .catch( (err) => {
        console.log(`GoogleMaps load error: ${err}`);
      })
    }
  }

  isScriptLoaded = (script) => {
    const scripts = document.getElementsByTagName('script');
      for (var i = scripts.length; i--;) {
          if (scripts[i].src == script) 
          {
            return true;
          }
      }

      return false;
  }

  scrollToSection = (idToScrollTo, offsetNum) => {
    let navigateTo = document.querySelector("#" + idToScrollTo);

    scrollToElement(navigateTo, {
      offset: offsetNum,
      align: "top",
      duration: 1000
    });
  }

  eventFire = (el, etype) => {
    if (el.fireEvent) {
      el.fireEvent('on' + etype);
    } else {
      var evObj = document.createEvent('Events');
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  itemAddedPopup = (name, quantity, image) => {
    this.setState({
      itemAddedPopupName: name,
      itemAddedPopupQuantity: quantity,
      itemAddedPopupImage: image,
      itemAddedPopupOpen: true
    });
  }
  itemAddedPopupClosing = () => { this.setState({itemAddedPopupOpen: false}); }

  onAfterOpen = () => { 
    document.getElementsByTagName("button").onclick = 
    (() => {
      document.getElementByClassName("sa-success").addClass("hide");
      setTimeout(() =>  {
        document.getElementByClassName("sa-success").removeClass("hide");
      }, 10);
    });

    this.itemAddedPopupClosing();
  }

  setWindowWidth = () => { this.setState({ windowWidth: window.innerWidth });  }

  aboutUsClick = () => {
    if(this.state.currentRoute.pathname == "/aboutUs") {
      this.scrollToSection("AboutUsSectionID", -115);
    }
  }

  render() {
    //const ExampleObject = ( <div></div> );

  return (
	<BrowserRouter>
			<App {...this.state} setCartItemCount={this.setCartItemCount} setCartPriceTotal={this.setCartPriceTotal}
				 setUser={this.setUser} setUserLoggedIn={this.setUserLoggedIn} logoutClick={this.logoutClick} loginClick={this.loginClick}
				 loggedInEmailClick={this.loggedInEmailClick} setDefaultCartStateValues={this.setDefaultCartStateValues} 
				 setCurrentRoute={this.setCurrentRoute} setPreviousRoute={this.setPreviousRoute} scrollToSection={this.scrollToSection}
         aboutUsClick={this.aboutUsClick} onAfterOpen={this.onAfterOpen} itemAddedPopupClosing={this.itemAddedPopupClosing} >
				<Switch>
					<Route path='/Shop/:initialFilter?' header="Shop" 
						render={(props) => ( <div>
            				{ this.state.products.length > 0 ? <Shop {...this.state} scrollToSection={this.scrollToSection} addItemToCartState={this.addItemToCartState}
                                                             addItemToCart={this.addItemToCart} setShopIsMounted={this.setShopIsMounted} /> : "" } 
		                </div> ) } />
					<Route path='/Offers' header="Offers" component={Offers} />
					<Route path='/FAQ' header="FAQ" component={FAQ} />
					<Route path='/ShippingHandling' header="ShippingHandling" component={ShippingHandling} />
					{/*<Route exact path='/FindFragrance' header="FindFragrance" component={FindFragrance} />*/}
					<Route path='/Contact' header="Contact" component={Contact} />

					<Route path='/Locator' header="Locator"
		              render={(props) => ( <div>
		                { this.state.googleMapsLoaded ? <Locator googleMapsObject={this.state.googleMapsObject} googleMapsLoaded={this.state.googleMapsLoaded} /> : "" }
		              </div> ) } />

          <Route exact path='/:scrollToSection?' header="Home" 
            render={(props) => ( <Home {...this.state} products={this.state.products} scrollToSection={this.scrollToSection} 
            setHomeIsMounted={this.setHomeIsMounted} windowWidth={this.state.windowWidth} addItemToCart={this.addItemToCart}
            /> ) } />

					<Route path='empty' key="empty" component={null} />
					<Route path='/404' header="404" component={NoMatch} />
					<Redirect to="/404" />
				</Switch>
			</App>
		</BrowserRouter>	

		);
	}
}




// WEBPACK FOOTER //
// ./src/Routes.js